// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdData, DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdErrors, DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdResponses, DeleteApiExchangeByEncryptedOrderIdData, DeleteApiExchangeByEncryptedOrderIdErrors, DeleteApiExchangeByEncryptedOrderIdResponses, DeleteApiOrdersByEncryptedOrderIdData, DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdData, DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdErrors, DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdResponses, DeleteApiOrdersByEncryptedOrderIdErrors, DeleteApiOrdersByEncryptedOrderIdEventByEventIdData, DeleteApiOrdersByEncryptedOrderIdEventByEventIdErrors, DeleteApiOrdersByEncryptedOrderIdEventByEventIdResponses, DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdData, DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdErrors, DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdResponses, DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdData, DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdErrors, DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdResponses, DeleteApiOrdersByEncryptedOrderIdProductsData, DeleteApiOrdersByEncryptedOrderIdProductsErrors, DeleteApiOrdersByEncryptedOrderIdProductsResponses, DeleteApiOrdersByEncryptedOrderIdResponses, DeleteApiOrdersByEncryptedOrderIdTicketsData, DeleteApiOrdersByEncryptedOrderIdTicketsErrors, DeleteApiOrdersByEncryptedOrderIdTicketsResponses, DeleteApiProfileMeData, DeleteApiProfileMeErrors, DeleteApiProfileMeResponses, DeleteApiTicketsData, DeleteApiTicketsErrors, DeleteApiTicketsResponses, GetApiAppsettingsAttributesData, GetApiAppsettingsAttributesErrors, GetApiAppsettingsAttributesResponses, GetApiAppsettingsData, GetApiAppsettingsErrors, GetApiAppsettingsPrivacyPolicyData, GetApiAppsettingsPrivacyPolicyErrors, GetApiAppsettingsPrivacyPolicyResponses, GetApiAppsettingsResponses, GetApiAppsettingsTermsAndConditionsData, GetApiAppsettingsTermsAndConditionsErrors, GetApiAppsettingsTermsAndConditionsResponses, GetApiAuthExternalCallbackData, GetApiAuthExternalCallbackResponses, GetApiAuthExternalProvidersData, GetApiAuthExternalProvidersErrors, GetApiAuthExternalProvidersResponses, GetApiAuthExternalStartData, GetApiAuthExternalStartResponses, GetApiCheckoutByEncryptedOrderIdData, GetApiCheckoutByEncryptedOrderIdErrors, GetApiCheckoutByEncryptedOrderIdOrderProtectionData, GetApiCheckoutByEncryptedOrderIdOrderProtectionErrors, GetApiCheckoutByEncryptedOrderIdOrderProtectionResponses, GetApiCheckoutByEncryptedOrderIdResponses, GetApiCurrenciesRatesData, GetApiCurrenciesRatesErrors, GetApiCurrenciesRatesResponses, GetApiDonationsByDonationIdData, GetApiDonationsByDonationIdErrors, GetApiDonationsByDonationIdResponses, GetApiDonationsData, GetApiDonationsErrors, GetApiDonationsGroupsByUrlData, GetApiDonationsGroupsByUrlErrors, GetApiDonationsGroupsByUrlResponses, GetApiDonationsGroupsData, GetApiDonationsGroupsErrors, GetApiDonationsGroupsResponses, GetApiDonationsResponses, GetApiEventGroupsByEventGroupIdData, GetApiEventGroupsByEventGroupIdErrors, GetApiEventGroupsByEventGroupIdEventsCalendarData, GetApiEventGroupsByEventGroupIdEventsCalendarErrors, GetApiEventGroupsByEventGroupIdEventsCalendarResponses, GetApiEventGroupsByEventGroupIdEventsPagedData, GetApiEventGroupsByEventGroupIdEventsPagedErrors, GetApiEventGroupsByEventGroupIdEventsPagedResponses, GetApiEventGroupsByEventGroupIdResponses, GetApiEventGroupsByEventGroupIdSpecialOffersData, GetApiEventGroupsByEventGroupIdSpecialOffersErrors, GetApiEventGroupsByEventGroupIdSpecialOffersResponses, GetApiEventGroupsData, GetApiEventGroupsErrors, GetApiEventGroupsResponses, GetApiEventsByEventIdData, GetApiEventsByEventIdErrors, GetApiEventsByEventIdProductsData, GetApiEventsByEventIdProductsErrors, GetApiEventsByEventIdProductsResponses, GetApiEventsByEventIdResponses, GetApiEventsByEventIdSeatsData, GetApiEventsByEventIdSeatsErrors, GetApiEventsByEventIdSeatsResponses, GetApiEventsByEventIdUniqueCustomerData, GetApiEventsByEventIdUniqueCustomerErrors, GetApiEventsByEventIdUniqueCustomerResponses, GetApiEventsByEventIdUpcomingData, GetApiEventsByEventIdUpcomingErrors, GetApiEventsByEventIdUpcomingResponses, GetApiExchangeByEncryptedOrderIdCartData, GetApiExchangeByEncryptedOrderIdCartErrors, GetApiExchangeByEncryptedOrderIdCartResponses, GetApiExchangeByEncryptedOrderIdEventsByEventIdData, GetApiExchangeByEncryptedOrderIdEventsByEventIdErrors, GetApiExchangeByEncryptedOrderIdEventsByEventIdResponses, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsData, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsErrors, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsResponses, GetApiForwardByTokenPdfData, GetApiForwardByTokenPdfErrors, GetApiForwardByTokenPdfResponses, GetApiGiftcardsGroupsByGiftCardGroupIdData, GetApiGiftcardsGroupsByGiftCardGroupIdErrors, GetApiGiftcardsGroupsByGiftCardGroupIdResponses, GetApiGiftcardsGroupsData, GetApiGiftcardsGroupsErrors, GetApiGiftcardsGroupsResponses, GetApiMembershipsByMembershipIdData, GetApiMembershipsByMembershipIdErrors, GetApiMembershipsByMembershipIdResponses, GetApiMembershipsData, GetApiMembershipsErrors, GetApiMembershipsGroupsByUrlData, GetApiMembershipsGroupsByUrlErrors, GetApiMembershipsGroupsByUrlResponses, GetApiMembershipsGroupsData, GetApiMembershipsGroupsErrors, GetApiMembershipsGroupsResponses, GetApiMembershipsResponses, GetApiMobilepassGiftcardByEncryptedGiftcardIdData, GetApiMobilepassGiftcardByEncryptedGiftcardIdErrors, GetApiMobilepassGiftcardByEncryptedGiftcardIdResponses, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdData, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdErrors, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdResponses, GetApiMobilepassOrderByEncryptedOrderIdData, GetApiMobilepassOrderByEncryptedOrderIdErrors, GetApiMobilepassOrderByEncryptedOrderIdResponses, GetApiMobilepassSubscriptionByEncryptedTicketIdData, GetApiMobilepassSubscriptionByEncryptedTicketIdErrors, GetApiMobilepassSubscriptionByEncryptedTicketIdResponses, GetApiMobilepassTicketByEncryptedTicketIdData, GetApiMobilepassTicketByEncryptedTicketIdErrors, GetApiMobilepassTicketByEncryptedTicketIdResponses, GetApiOrdersByEncryptedOrderIdData, GetApiOrdersByEncryptedOrderIdDeliveryTypesData, GetApiOrdersByEncryptedOrderIdDeliveryTypesErrors, GetApiOrdersByEncryptedOrderIdDeliveryTypesResponses, GetApiOrdersByEncryptedOrderIdDiscountClubsData, GetApiOrdersByEncryptedOrderIdDiscountClubsErrors, GetApiOrdersByEncryptedOrderIdDiscountClubsResponses, GetApiOrdersByEncryptedOrderIdErrors, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesErrors, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponses, GetApiOrdersByEncryptedOrderIdResponses, GetApiProfileEventsByEventIdAttendeesData, GetApiProfileEventsByEventIdAttendeesErrors, GetApiProfileEventsByEventIdAttendeesResponses, GetApiProfileGiftcardsData, GetApiProfileGiftcardsErrors, GetApiProfileGiftcardsResponses, GetApiProfileMeData, GetApiProfileMeErrors, GetApiProfileMeExportData, GetApiProfileMeExportErrors, GetApiProfileMeExportResponses, GetApiProfileMembershipsData, GetApiProfileMembershipsErrors, GetApiProfileMembershipsResponses, GetApiProfileMePermissionsData, GetApiProfileMePermissionsErrors, GetApiProfileMePermissionsResponses, GetApiProfileMeResponses, GetApiProfileOrdersData, GetApiProfileOrdersErrors, GetApiProfileOrdersResponses, GetApiReceiptByEncryptedOrderIdData, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfData, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfErrors, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfResponses, GetApiReceiptByEncryptedOrderIdErrors, GetApiReceiptByEncryptedOrderIdRefundByEventIdData, GetApiReceiptByEncryptedOrderIdRefundByEventIdErrors, GetApiReceiptByEncryptedOrderIdRefundByEventIdResponses, GetApiReceiptByEncryptedOrderIdResponses, GetApiReceiptByEncryptedOrderIdStatusData, GetApiReceiptByEncryptedOrderIdStatusErrors, GetApiReceiptByEncryptedOrderIdStatusResponses, GetApiSpecialOffersByEncryptedSpecialOfferIdData, GetApiSpecialOffersByEncryptedSpecialOfferIdErrors, GetApiSpecialOffersByEncryptedSpecialOfferIdResponses, GetApiSpecialOffersData, GetApiSpecialOffersErrors, GetApiSpecialOffersResponses, GetApiSubscriptionTypesBySubscriptionTypeIdData, GetApiSubscriptionTypesBySubscriptionTypeIdErrors, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsData, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsErrors, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsResponses, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsData, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsErrors, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsResponses, GetApiSubscriptionTypesBySubscriptionTypeIdResponses, GetApiSubscriptionTypesData, GetApiSubscriptionTypesErrors, GetApiSubscriptionTypesResponses, GetApiVersionData, GetApiVersionResponses, PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdData, PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdErrors, PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdResponses, PatchApiCheckoutByEncryptedOrderIdPaymentSessionData, PatchApiCheckoutByEncryptedOrderIdPaymentSessionErrors, PatchApiCheckoutByEncryptedOrderIdPaymentSessionResponses, PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData, PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesErrors, PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponses, PatchApiProfileEventsByEventIdAttendeesData, PatchApiProfileEventsByEventIdAttendeesErrors, PatchApiProfileEventsByEventIdAttendeesResponses, PatchApiProfileMeDateOfBirthData, PatchApiProfileMeDateOfBirthErrors, PatchApiProfileMeDateOfBirthResponses, PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdData, PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdErrors, PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdResponses, PostApiAuthChangePasswordData, PostApiAuthChangePasswordErrors, PostApiAuthChangePasswordResponses, PostApiAuthConfirmRegistrationData, PostApiAuthConfirmRegistrationErrors, PostApiAuthConfirmRegistrationResponses, PostApiAuthExternalDisconnectData, PostApiAuthExternalDisconnectErrors, PostApiAuthExternalDisconnectResponses, PostApiAuthExternalExchangeData, PostApiAuthExternalExchangeErrors, PostApiAuthExternalExchangeResponses, PostApiAuthExternalLoginData, PostApiAuthExternalLoginErrors, PostApiAuthExternalLoginResponses, PostApiAuthForgotPasswordData, PostApiAuthForgotPasswordErrors, PostApiAuthForgotPasswordResponses, PostApiAuthLoginData, PostApiAuthLoginErrors, PostApiAuthLoginResponses, PostApiAuthLogoutData, PostApiAuthLogoutErrors, PostApiAuthRefreshData, PostApiAuthRefreshErrors, PostApiAuthRefreshResponses, PostApiAuthResetPasswordData, PostApiAuthResetPasswordErrors, PostApiAuthResetPasswordResponses, PostApiAuthSignupData, PostApiAuthSignupErrors, PostApiAuthSignupResponses, PostApiAuthWebuserExistsData, PostApiAuthWebuserExistsErrors, PostApiAuthWebuserExistsResponses, PostApiCacheClearByTenantIdByKeyData, PostApiCacheClearByTenantIdByKeyErrors, PostApiCacheClearByTenantIdByKeyResponses, PostApiCheckoutByEncryptedOrderIdConfirmPaymentData, PostApiCheckoutByEncryptedOrderIdConfirmPaymentErrors, PostApiCheckoutByEncryptedOrderIdConfirmPaymentResponses, PostApiCheckoutByEncryptedOrderIdDetailsData, PostApiCheckoutByEncryptedOrderIdDetailsErrors, PostApiCheckoutByEncryptedOrderIdDetailsResponses, PostApiCheckoutByEncryptedOrderIdGiftcardData, PostApiCheckoutByEncryptedOrderIdGiftcardErrors, PostApiCheckoutByEncryptedOrderIdGiftcardResponses, PostApiCheckoutByEncryptedOrderIdGiftcardValidateData, PostApiCheckoutByEncryptedOrderIdGiftcardValidateErrors, PostApiCheckoutByEncryptedOrderIdGiftcardValidateResponses, PostApiCheckoutByEncryptedOrderIdPaymentSessionData, PostApiCheckoutByEncryptedOrderIdPaymentSessionErrors, PostApiCheckoutByEncryptedOrderIdPaymentSessionResponses, PostApiCheckoutByEncryptedOrderIdReserveData, PostApiCheckoutByEncryptedOrderIdReserveErrors, PostApiCheckoutByEncryptedOrderIdReserveResponses, PostApiEventsByEventIdSeatsAutoReserveData, PostApiEventsByEventIdSeatsAutoReserveErrors, PostApiEventsByEventIdSeatsAutoReserveResponses, PostApiEventsByEventIdSeatsMoveData, PostApiEventsByEventIdSeatsMoveErrors, PostApiEventsByEventIdSeatsMoveResponses, PostApiEventsByEventIdSeatsReserveData, PostApiEventsByEventIdSeatsReserveErrors, PostApiEventsByEventIdSeatsReserveResponses, PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmData, PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmErrors, PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmResponses, PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartData, PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartErrors, PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartResponses, PostApiExchangeByEncryptedOrderIdFinalizeData, PostApiExchangeByEncryptedOrderIdFinalizeErrors, PostApiExchangeByEncryptedOrderIdFinalizeResponses, PostApiExchangeByEncryptedOrderIdPaymentSessionData, PostApiExchangeByEncryptedOrderIdPaymentSessionErrors, PostApiExchangeByEncryptedOrderIdPaymentSessionResponses, PostApiForwardData, PostApiForwardErrors, PostApiForwardLinkData, PostApiForwardLinkErrors, PostApiForwardLinkResponses, PostApiForwardResponses, PostApiGiftcardsPreviewPdfData, PostApiGiftcardsPreviewPdfErrors, PostApiGiftcardsPreviewPdfResponses, PostApiGiftcardsStatusData, PostApiGiftcardsStatusErrors, PostApiGiftcardsStatusResponses, PostApiInternalOrdersByOrderIdBriqpayRefundData, PostApiInternalOrdersByOrderIdBriqpayRefundErrors, PostApiInternalOrdersByOrderIdBriqpayRefundResponses, PostApiInternalOrdersByOrderIdCloseSaleData, PostApiInternalOrdersByOrderIdCloseSaleErrors, PostApiInternalOrdersByOrderIdCloseSaleResponses, PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksData, PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksErrors, PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksResponses, PostApiOrdersByEncryptedOrderIdClaimData, PostApiOrdersByEncryptedOrderIdClaimErrors, PostApiOrdersByEncryptedOrderIdClaimResponses, PostApiOrdersByEncryptedOrderIdCustomerNoteData, PostApiOrdersByEncryptedOrderIdCustomerNoteErrors, PostApiOrdersByEncryptedOrderIdCustomerNoteResponses, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyData, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyErrors, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyResponses, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewData, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewErrors, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewResponses, PostApiOrdersByEncryptedOrderIdDiscountCodeData, PostApiOrdersByEncryptedOrderIdDiscountCodeErrors, PostApiOrdersByEncryptedOrderIdDiscountCodeResponses, PostApiOrdersByEncryptedOrderIdDonationsData, PostApiOrdersByEncryptedOrderIdDonationsErrors, PostApiOrdersByEncryptedOrderIdDonationsResponses, PostApiOrdersByEncryptedOrderIdEvaluateRulesData, PostApiOrdersByEncryptedOrderIdEvaluateRulesErrors, PostApiOrdersByEncryptedOrderIdEvaluateRulesResponses, PostApiOrdersByEncryptedOrderIdExpiryExtendData, PostApiOrdersByEncryptedOrderIdExpiryExtendErrors, PostApiOrdersByEncryptedOrderIdExpiryExtendResponses, PostApiOrdersByEncryptedOrderIdGiftcardsData, PostApiOrdersByEncryptedOrderIdGiftcardsErrors, PostApiOrdersByEncryptedOrderIdGiftcardsResponses, PostApiOrdersByEncryptedOrderIdMembershipsData, PostApiOrdersByEncryptedOrderIdMembershipsErrors, PostApiOrdersByEncryptedOrderIdMembershipsResponses, PostApiOrdersByEncryptedOrderIdProductsData, PostApiOrdersByEncryptedOrderIdProductsErrors, PostApiOrdersByEncryptedOrderIdProductsResponses, PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdData, PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdErrors, PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdResponses, PostApiOrdersByEncryptedOrderIdSplitData, PostApiOrdersByEncryptedOrderIdSplitErrors, PostApiOrdersByEncryptedOrderIdSplitResponses, PostApiOrdersByEncryptedOrderIdTicketsData, PostApiOrdersByEncryptedOrderIdTicketsErrors, PostApiOrdersByEncryptedOrderIdTicketsResponses, PostApiOrdersByEncryptedOrderIdTicketsUnnumberedData, PostApiOrdersByEncryptedOrderIdTicketsUnnumberedErrors, PostApiOrdersByEncryptedOrderIdTicketsUnnumberedResponses, PostApiOrdersData, PostApiOrdersErrors, PostApiOrdersResponses, PostApiProfileMeData, PostApiProfileMeErrors, PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalData, PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalErrors, PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalResponses, PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalData, PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalErrors, PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalResponses, PostApiProfileMeResponses, PostApiPurchaseByEncryptedOrderIdData, PostApiPurchaseByEncryptedOrderIdErrors, PostApiPurchaseByEncryptedOrderIdResponses, PostApiReceiptByEncryptedOrderIdRefundByEventIdData, PostApiReceiptByEncryptedOrderIdRefundByEventIdErrors, PostApiReceiptByEncryptedOrderIdRefundByEventIdResponses, PostApiTicketsValidateData, PostApiTicketsValidateErrors, PostApiTicketsValidateResponses, PostApiWaitingListByEventIdSignupData, PostApiWaitingListByEventIdSignupErrors, PostApiWaitingListByEventIdSignupResponses, PostApiWaitingListConfirmData, PostApiWaitingListConfirmErrors, PostApiWaitingListConfirmResponses, PutApiCheckoutByEncryptedOrderIdOrderProtectionData, PutApiCheckoutByEncryptedOrderIdOrderProtectionErrors, PutApiCheckoutByEncryptedOrderIdOrderProtectionResponses, PutApiProfileMePermissionsByPermissionIdData, PutApiProfileMePermissionsByPermissionIdErrors, PutApiProfileMePermissionsByPermissionIdResponses } from './types.gen';
export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Retrieves Tenant and Skin specific appsettings.
 */
export const getApiAppsettings = <ThrowOnError extends boolean = false,>(options?: Options<GetApiAppsettingsData, ThrowOnError>): RequestResult<GetApiAppsettingsResponses, GetApiAppsettingsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiAppsettingsResponses, GetApiAppsettingsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/appsettings',
  ...options
});

/**
 * Retrieves customer attribute settings.
 */
export const getApiAppsettingsAttributes = <ThrowOnError extends boolean = false,>(options?: Options<GetApiAppsettingsAttributesData, ThrowOnError>): RequestResult<GetApiAppsettingsAttributesResponses, GetApiAppsettingsAttributesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiAppsettingsAttributesResponses, GetApiAppsettingsAttributesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/appsettings/attributes',
  ...options
});

/**
 * Retrieves the skin's terms and conditions in the request culture.
 */
export const getApiAppsettingsTermsAndConditions = <ThrowOnError extends boolean = false,>(options?: Options<GetApiAppsettingsTermsAndConditionsData, ThrowOnError>): RequestResult<GetApiAppsettingsTermsAndConditionsResponses, GetApiAppsettingsTermsAndConditionsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiAppsettingsTermsAndConditionsResponses, GetApiAppsettingsTermsAndConditionsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/appsettings/terms-and-conditions',
  ...options
});

/**
 * Retrieves the skin's privacy policy in the request culture.
 */
export const getApiAppsettingsPrivacyPolicy = <ThrowOnError extends boolean = false,>(options?: Options<GetApiAppsettingsPrivacyPolicyData, ThrowOnError>): RequestResult<GetApiAppsettingsPrivacyPolicyResponses, GetApiAppsettingsPrivacyPolicyErrors, ThrowOnError> => (options?.client ?? client).get<GetApiAppsettingsPrivacyPolicyResponses, GetApiAppsettingsPrivacyPolicyErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/appsettings/privacy-policy',
  ...options
});

/**
 * Logs in a web user and retrieves a pair of tokens: access and refresh
 */
export const postApiAuthLogin = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthLoginData, ThrowOnError>): RequestResult<PostApiAuthLoginResponses, PostApiAuthLoginErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthLoginResponses, PostApiAuthLoginErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/login',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Registers a new web user and retrieves a pair of tokens: access and refresh
 */
export const postApiAuthSignup = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthSignupData, ThrowOnError>): RequestResult<PostApiAuthSignupResponses, PostApiAuthSignupErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthSignupResponses, PostApiAuthSignupErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/signup',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Checks whether a webuser already exists in the current skin matching any of the
 * supplied unique-on-webuser identifiers (Email, Mobile). Used by the signup gate
 * to branch to login when the identity is already taken.
 */
export const postApiAuthWebuserExists = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthWebuserExistsData, ThrowOnError>): RequestResult<PostApiAuthWebuserExistsResponses, PostApiAuthWebuserExistsErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthWebuserExistsResponses, PostApiAuthWebuserExistsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/webuser-exists',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Validates tokens and issues a new pair of tokens upon success
 */
export const postApiAuthRefresh = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthRefreshData, ThrowOnError>): RequestResult<PostApiAuthRefreshResponses, PostApiAuthRefreshErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthRefreshResponses, PostApiAuthRefreshErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/refresh',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Validates hashKey and resets user's password to a new one
 */
export const postApiAuthResetPassword = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthResetPasswordData, ThrowOnError>): RequestResult<PostApiAuthResetPasswordResponses, PostApiAuthResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthResetPasswordResponses, PostApiAuthResetPasswordErrors, ThrowOnError>({
  url: '/api/auth/reset-password',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Confirms a freshly registered webuser via the signup email link
 */
export const postApiAuthConfirmRegistration = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthConfirmRegistrationData, ThrowOnError>): RequestResult<PostApiAuthConfirmRegistrationResponses, PostApiAuthConfirmRegistrationErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthConfirmRegistrationResponses, PostApiAuthConfirmRegistrationErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/confirm-registration',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Updates the user's password to a new one
 */
export const postApiAuthChangePassword = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthChangePasswordData, ThrowOnError>): RequestResult<PostApiAuthChangePasswordResponses, PostApiAuthChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthChangePasswordResponses, PostApiAuthChangePasswordErrors, ThrowOnError>({
  url: '/api/auth/change-password',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Initiates a new procedure for resetting a user's password
 */
export const postApiAuthForgotPassword = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthForgotPasswordData, ThrowOnError>): RequestResult<PostApiAuthForgotPasswordResponses, PostApiAuthForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthForgotPasswordResponses, PostApiAuthForgotPasswordErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/forgot-password',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Allows authenticated user to logout
 */
export const postApiAuthLogout = <ThrowOnError extends boolean = false,>(options?: Options<PostApiAuthLogoutData, ThrowOnError>): RequestResult<unknown, PostApiAuthLogoutErrors, ThrowOnError> => (options?.client ?? client).post<unknown, PostApiAuthLogoutErrors, ThrowOnError>({
  url: '/api/auth/logout',
  ...options
});

/**
 * Evicts the cached entries for tenantId. Requires the shared admin key configured
 * in `Cache:AdminClearKey`; returns 401 if the key is missing or doesn't match, 400 if the tenant
 * is not a configured tenant.
 */
export const postApiCacheClearByTenantIdByKey = <ThrowOnError extends boolean = false,>(options: Options<PostApiCacheClearByTenantIdByKeyData, ThrowOnError>): RequestResult<PostApiCacheClearByTenantIdByKeyResponses, PostApiCacheClearByTenantIdByKeyErrors, ThrowOnError> => (options.client ?? client).post<PostApiCacheClearByTenantIdByKeyResponses, PostApiCacheClearByTenantIdByKeyErrors, ThrowOnError>({
  url: '/api/cache/clear/{tenantId}/{key}',
  ...options
});

/**
 * Fetches necessary information to proceed to checkout
 */
export const getApiCheckoutByEncryptedOrderId = <ThrowOnError extends boolean = false,>(options: Options<GetApiCheckoutByEncryptedOrderIdData, ThrowOnError>): RequestResult<GetApiCheckoutByEncryptedOrderIdResponses, GetApiCheckoutByEncryptedOrderIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiCheckoutByEncryptedOrderIdResponses, GetApiCheckoutByEncryptedOrderIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}',
  ...options
});

/**
 * Prices order protection for the order, or reports that it is not on offer.
 */
export const getApiCheckoutByEncryptedOrderIdOrderProtection = <ThrowOnError extends boolean = false,>(options: Options<GetApiCheckoutByEncryptedOrderIdOrderProtectionData, ThrowOnError>): RequestResult<GetApiCheckoutByEncryptedOrderIdOrderProtectionResponses, GetApiCheckoutByEncryptedOrderIdOrderProtectionErrors, ThrowOnError> => (options.client ?? client).get<GetApiCheckoutByEncryptedOrderIdOrderProtectionResponses, GetApiCheckoutByEncryptedOrderIdOrderProtectionErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/order-protection',
  ...options
});

/**
 * Records the buyer's answer to order protection and puts the fee on the order, or takes it off.
 */
export const putApiCheckoutByEncryptedOrderIdOrderProtection = <ThrowOnError extends boolean = false,>(options: Options<PutApiCheckoutByEncryptedOrderIdOrderProtectionData, ThrowOnError>): RequestResult<PutApiCheckoutByEncryptedOrderIdOrderProtectionResponses, PutApiCheckoutByEncryptedOrderIdOrderProtectionErrors, ThrowOnError> => (options.client ?? client).put<PutApiCheckoutByEncryptedOrderIdOrderProtectionResponses, PutApiCheckoutByEncryptedOrderIdOrderProtectionErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/order-protection',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Pre-validates a gift card against the current order: existence, balance, expiry, in-use, group-event coverage.
 * Soft-fail states (not found, in use, expired) surface as flags on the response; hard-fail order-compat issues return an error.
 */
export const postApiCheckoutByEncryptedOrderIdGiftcardValidate = <ThrowOnError extends boolean = false,>(options: Options<PostApiCheckoutByEncryptedOrderIdGiftcardValidateData, ThrowOnError>): RequestResult<PostApiCheckoutByEncryptedOrderIdGiftcardValidateResponses, PostApiCheckoutByEncryptedOrderIdGiftcardValidateErrors, ThrowOnError> => (options.client ?? client).post<PostApiCheckoutByEncryptedOrderIdGiftcardValidateResponses, PostApiCheckoutByEncryptedOrderIdGiftcardValidateErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/giftcard/validate',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Registers a gift card to the current order
 */
export const postApiCheckoutByEncryptedOrderIdGiftcard = <ThrowOnError extends boolean = false,>(options: Options<PostApiCheckoutByEncryptedOrderIdGiftcardData, ThrowOnError>): RequestResult<PostApiCheckoutByEncryptedOrderIdGiftcardResponses, PostApiCheckoutByEncryptedOrderIdGiftcardErrors, ThrowOnError> => (options.client ?? client).post<PostApiCheckoutByEncryptedOrderIdGiftcardResponses, PostApiCheckoutByEncryptedOrderIdGiftcardErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/giftcard',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Remove a gift card from the current order
 */
export const deleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentId = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdData, ThrowOnError>): RequestResult<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdResponses, DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdResponses, DeleteApiCheckoutByEncryptedOrderIdGiftcardByOrderPaymentIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/giftcard/{orderPaymentId}',
  ...options
});

/**
 * Updates delivery type for the current order
 */
export const patchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeId = <ThrowOnError extends boolean = false,>(options: Options<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdData, ThrowOnError>): RequestResult<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdResponses, PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdResponses, PatchApiCheckoutByEncryptedOrderIdDeliverytypeByDeliveryTypeIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/deliverytype/{deliveryTypeId}',
  ...options
});

/**
 * Restates the order's cart and buyer onto its open Briqpay session after the order changed at
 * checkout, so the open iframe charges what the order now owes. Call it between the iframe's
 * suspend and resume, never after the buyer pressed pay. On failure open a new session instead.
 */
export const patchApiCheckoutByEncryptedOrderIdPaymentSession = <ThrowOnError extends boolean = false,>(options: Options<PatchApiCheckoutByEncryptedOrderIdPaymentSessionData, ThrowOnError>): RequestResult<PatchApiCheckoutByEncryptedOrderIdPaymentSessionResponses, PatchApiCheckoutByEncryptedOrderIdPaymentSessionErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiCheckoutByEncryptedOrderIdPaymentSessionResponses, PatchApiCheckoutByEncryptedOrderIdPaymentSessionErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/payment-session',
  ...options
});

/**
 * Creates a Briqpay payment session for the order via tix.payment, returning the embeddable iframe snippet.
 */
export const postApiCheckoutByEncryptedOrderIdPaymentSession = <ThrowOnError extends boolean = false,>(options: Options<PostApiCheckoutByEncryptedOrderIdPaymentSessionData, ThrowOnError>): RequestResult<PostApiCheckoutByEncryptedOrderIdPaymentSessionResponses, PostApiCheckoutByEncryptedOrderIdPaymentSessionErrors, ThrowOnError> => (options.client ?? client).post<PostApiCheckoutByEncryptedOrderIdPaymentSessionResponses, PostApiCheckoutByEncryptedOrderIdPaymentSessionErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/payment-session',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Confirms the external payment once the customer returns from Briqpay: verifies the session
 * server-side and, when approved, closes the sale in-process so the receipt is ready without
 * waiting for the batched webhook. The browser's success flag is only the trigger — proof of
 * payment is the server-side session check.
 */
export const postApiCheckoutByEncryptedOrderIdConfirmPayment = <ThrowOnError extends boolean = false,>(options: Options<PostApiCheckoutByEncryptedOrderIdConfirmPaymentData, ThrowOnError>): RequestResult<PostApiCheckoutByEncryptedOrderIdConfirmPaymentResponses, PostApiCheckoutByEncryptedOrderIdConfirmPaymentErrors, ThrowOnError> => (options.client ?? client).post<PostApiCheckoutByEncryptedOrderIdConfirmPaymentResponses, PostApiCheckoutByEncryptedOrderIdConfirmPaymentErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/confirm-payment',
  ...options
});

/**
 * Reserves the order instead of paying for it. Requires a signed-in buyer and a workgroup that
 * offers online reservations. Extends the order's expiry per those settings.
 */
export const postApiCheckoutByEncryptedOrderIdReserve = <ThrowOnError extends boolean = false,>(options: Options<PostApiCheckoutByEncryptedOrderIdReserveData, ThrowOnError>): RequestResult<PostApiCheckoutByEncryptedOrderIdReserveResponses, PostApiCheckoutByEncryptedOrderIdReserveErrors, ThrowOnError> => (options.client ?? client).post<PostApiCheckoutByEncryptedOrderIdReserveResponses, PostApiCheckoutByEncryptedOrderIdReserveErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/reserve',
  ...options
});

/**
 * Saves the customer's details before external payment: customer create/update, optional web user, links the customer
 * to the order, and bumps the order's expiry to give the customer time to complete payment.
 */
export const postApiCheckoutByEncryptedOrderIdDetails = <ThrowOnError extends boolean = false,>(options: Options<PostApiCheckoutByEncryptedOrderIdDetailsData, ThrowOnError>): RequestResult<PostApiCheckoutByEncryptedOrderIdDetailsResponses, PostApiCheckoutByEncryptedOrderIdDetailsErrors, ThrowOnError> => (options.client ?? client).post<PostApiCheckoutByEncryptedOrderIdDetailsResponses, PostApiCheckoutByEncryptedOrderIdDetailsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/checkout/{encryptedOrderId}/details',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Retrieves available currency rates
 */
export const getApiCurrenciesRates = <ThrowOnError extends boolean = false,>(options?: Options<GetApiCurrenciesRatesData, ThrowOnError>): RequestResult<GetApiCurrenciesRatesResponses, GetApiCurrenciesRatesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiCurrenciesRatesResponses, GetApiCurrenciesRatesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/currencies/rates',
  ...options
});

/**
 * The discount clubs offered for the order, each with the form the buyer fills in. A club with
 * no ticket left to discount is not listed.
 */
export const getApiOrdersByEncryptedOrderIdDiscountClubs = <ThrowOnError extends boolean = false,>(options: Options<GetApiOrdersByEncryptedOrderIdDiscountClubsData, ThrowOnError>): RequestResult<GetApiOrdersByEncryptedOrderIdDiscountClubsResponses, GetApiOrdersByEncryptedOrderIdDiscountClubsErrors, ThrowOnError> => (options.client ?? client).get<GetApiOrdersByEncryptedOrderIdDiscountClubsResponses, GetApiOrdersByEncryptedOrderIdDiscountClubsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/discount-clubs',
  ...options
});

/**
 * Prices a card against the order's tickets without applying it.
 */
export const postApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreview = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewResponses, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewResponses, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdPreviewErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/discount-clubs/{couponTypeId}/preview',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Applies a card: the discounted tickets move to the club's ticket type and price.
 */
export const postApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApply = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyResponses, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyResponses, PostApiOrdersByEncryptedOrderIdDiscountClubsByCouponTypeIdApplyErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/discount-clubs/{couponTypeId}/apply',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Retrieves available donations for the Skin
 */
export const getApiDonations = <ThrowOnError extends boolean = false,>(options?: Options<GetApiDonationsData, ThrowOnError>): RequestResult<GetApiDonationsResponses, GetApiDonationsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiDonationsResponses, GetApiDonationsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/donations',
  ...options
});

/**
 * Retrieves a donation by ID
 */
export const getApiDonationsByDonationId = <ThrowOnError extends boolean = false,>(options: Options<GetApiDonationsByDonationIdData, ThrowOnError>): RequestResult<GetApiDonationsByDonationIdResponses, GetApiDonationsByDonationIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiDonationsByDonationIdResponses, GetApiDonationsByDonationIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/donations/{donationId}',
  ...options
});

/**
 * Retrieves available Donation Groups for the Skin
 */
export const getApiDonationsGroups = <ThrowOnError extends boolean = false,>(options?: Options<GetApiDonationsGroupsData, ThrowOnError>): RequestResult<GetApiDonationsGroupsResponses, GetApiDonationsGroupsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiDonationsGroupsResponses, GetApiDonationsGroupsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/donations/groups',
  ...options
});

/**
 * Retrieves Donation Group detail by URL slug
 */
export const getApiDonationsGroupsByUrl = <ThrowOnError extends boolean = false,>(options: Options<GetApiDonationsGroupsByUrlData, ThrowOnError>): RequestResult<GetApiDonationsGroupsByUrlResponses, GetApiDonationsGroupsByUrlErrors, ThrowOnError> => (options.client ?? client).get<GetApiDonationsGroupsByUrlResponses, GetApiDonationsGroupsByUrlErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/donations/groups/{url}',
  ...options
});

/**
 * Get Event by Id
 */
export const getApiEventsByEventId = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventsByEventIdData, ThrowOnError>): RequestResult<GetApiEventsByEventIdResponses, GetApiEventsByEventIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventsByEventIdResponses, GetApiEventsByEventIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/events/{eventId}',
  ...options
});

/**
 *     Retrieves available seats by eventId, including those from special offers.
 * Pass includeSeats as false for the section map on its own, then
 * eventSectionIds to pull in a section's seats as the buyer opens it.
 * The map call describes the whole hall and carries the artwork; a call naming sections answers
 * for those sections alone, since seat availability is only read for them.
 */
export const getApiEventsByEventIdSeats = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventsByEventIdSeatsData, ThrowOnError>): RequestResult<GetApiEventsByEventIdSeatsResponses, GetApiEventsByEventIdSeatsErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventsByEventIdSeatsResponses, GetApiEventsByEventIdSeatsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/events/{eventId}/seats',
  ...options
});

/**
 * Reserves seats
 */
export const postApiEventsByEventIdSeatsReserve = <ThrowOnError extends boolean = false,>(options: Options<PostApiEventsByEventIdSeatsReserveData, ThrowOnError>): RequestResult<PostApiEventsByEventIdSeatsReserveResponses, PostApiEventsByEventIdSeatsReserveErrors, ThrowOnError> => (options.client ?? client).post<PostApiEventsByEventIdSeatsReserveResponses, PostApiEventsByEventIdSeatsReserveErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/events/{eventId}/seats/reserve',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reserves seats by using filters
 */
export const postApiEventsByEventIdSeatsAutoReserve = <ThrowOnError extends boolean = false,>(options: Options<PostApiEventsByEventIdSeatsAutoReserveData, ThrowOnError>): RequestResult<PostApiEventsByEventIdSeatsAutoReserveResponses, PostApiEventsByEventIdSeatsAutoReserveErrors, ThrowOnError> => (options.client ?? client).post<PostApiEventsByEventIdSeatsAutoReserveResponses, PostApiEventsByEventIdSeatsAutoReserveErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/events/{eventId}/seats/auto-reserve',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Moves reserved seats to new seats around a target seat
 */
export const postApiEventsByEventIdSeatsMove = <ThrowOnError extends boolean = false,>(options: Options<PostApiEventsByEventIdSeatsMoveData, ThrowOnError>): RequestResult<PostApiEventsByEventIdSeatsMoveResponses, PostApiEventsByEventIdSeatsMoveErrors, ThrowOnError> => (options.client ?? client).post<PostApiEventsByEventIdSeatsMoveResponses, PostApiEventsByEventIdSeatsMoveErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/events/{eventId}/seats/move',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Returns the upcoming-event landing page for the authenticated customer: the event, its
 * production description, venue, sibling showtimes, every order the customer holds and their
 * tickets for this event. Requires a logged-in customer.
 */
export const getApiEventsByEventIdUpcoming = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventsByEventIdUpcomingData, ThrowOnError>): RequestResult<GetApiEventsByEventIdUpcomingResponses, GetApiEventsByEventIdUpcomingErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventsByEventIdUpcomingResponses, GetApiEventsByEventIdUpcomingErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/events/{eventId}/upcoming',
  ...options
});

/**
 * Gets unique customer constraints for an event
 */
export const getApiEventsByEventIdUniqueCustomer = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventsByEventIdUniqueCustomerData, ThrowOnError>): RequestResult<GetApiEventsByEventIdUniqueCustomerResponses, GetApiEventsByEventIdUniqueCustomerErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventsByEventIdUniqueCustomerResponses, GetApiEventsByEventIdUniqueCustomerErrors, ThrowOnError>({
  url: '/api/events/{eventId}/unique-customer',
  ...options
});

/**
 * Retrieves all available event groups
 */
export const getApiEventGroups = <ThrowOnError extends boolean = false,>(options?: Options<GetApiEventGroupsData, ThrowOnError>): RequestResult<GetApiEventGroupsResponses, GetApiEventGroupsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiEventGroupsResponses, GetApiEventGroupsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/event-groups',
  ...options
});

/**
 * Retrieves available group events by eventGroupId
 */
export const getApiEventGroupsByEventGroupId = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventGroupsByEventGroupIdData, ThrowOnError>): RequestResult<GetApiEventGroupsByEventGroupIdResponses, GetApiEventGroupsByEventGroupIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventGroupsByEventGroupIdResponses, GetApiEventGroupsByEventGroupIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/event-groups/{eventGroupId}',
  ...options
});

/**
 * Retrieves available paged events by eventGroupId and as optional special offers
 */
export const getApiEventGroupsByEventGroupIdEventsPaged = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventGroupsByEventGroupIdEventsPagedData, ThrowOnError>): RequestResult<GetApiEventGroupsByEventGroupIdEventsPagedResponses, GetApiEventGroupsByEventGroupIdEventsPagedErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventGroupsByEventGroupIdEventsPagedResponses, GetApiEventGroupsByEventGroupIdEventsPagedErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/event-groups/{eventGroupId}/events/paged',
  ...options
});

/**
 * Retrieves available events for calendar view by eventGroupId and as optional special offers
 */
export const getApiEventGroupsByEventGroupIdEventsCalendar = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventGroupsByEventGroupIdEventsCalendarData, ThrowOnError>): RequestResult<GetApiEventGroupsByEventGroupIdEventsCalendarResponses, GetApiEventGroupsByEventGroupIdEventsCalendarErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventGroupsByEventGroupIdEventsCalendarResponses, GetApiEventGroupsByEventGroupIdEventsCalendarErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/event-groups/{eventGroupId}/events/calendar',
  ...options
});

/**
 * Returns all special offers tied to the event group specified by eventGroupId
 */
export const getApiEventGroupsByEventGroupIdSpecialOffers = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventGroupsByEventGroupIdSpecialOffersData, ThrowOnError>): RequestResult<GetApiEventGroupsByEventGroupIdSpecialOffersResponses, GetApiEventGroupsByEventGroupIdSpecialOffersErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventGroupsByEventGroupIdSpecialOffersResponses, GetApiEventGroupsByEventGroupIdSpecialOffersErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/event-groups/{eventGroupId}/special-offers',
  ...options
});

/**
 * Returns exchange eligibility rules and the list of candidate event groups for an order/event.
 * Use subscriptionTypeId to scope to a specific subscription group; omit it
 * (or pass null) to target non-subscription tickets when an order has both kinds for the event.
 */
export const getApiExchangeByEncryptedOrderIdEventsByEventId = <ThrowOnError extends boolean = false,>(options: Options<GetApiExchangeByEncryptedOrderIdEventsByEventIdData, ThrowOnError>): RequestResult<GetApiExchangeByEncryptedOrderIdEventsByEventIdResponses, GetApiExchangeByEncryptedOrderIdEventsByEventIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiExchangeByEncryptedOrderIdEventsByEventIdResponses, GetApiExchangeByEncryptedOrderIdEventsByEventIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/exchange/{encryptedOrderId}/events/{eventId}',
  ...options
});

/**
 * Returns the events within a candidate event group that are actually eligible for exchange for the
 * given order/event. The generic events endpoint is not exchange-aware and would list dates that
 * fail downstream, so the frontend uses this to populate the date picker. Pass
 * subscriptionTypeId to scope to a subscription group; omit it for non-subscription tickets.
 */
export const getApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEvents = <ThrowOnError extends boolean = false,>(options: Options<GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsData, ThrowOnError>): RequestResult<GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsResponses, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsErrors, ThrowOnError> => (options.client ?? client).get<GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsResponses, GetApiExchangeByEncryptedOrderIdEventsByOldEventIdGroupsByGroupIdEventsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/exchange/{encryptedOrderId}/events/{oldEventId}/groups/{groupId}/events',
  ...options
});

/**
 * Starts an in-flight exchange: creates a Reserved exchange (staging) order from the already-reserved
 * new tickets and returns its encrypted id for the frontend to drive cart/checkout against.
 */
export const postApiExchangeByEncryptedOrderIdEventsByOldEventIdStart = <ThrowOnError extends boolean = false,>(options: Options<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartData, ThrowOnError>): RequestResult<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartResponses, PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartErrors, ThrowOnError> => (options.client ?? client).post<PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartResponses, PostApiExchangeByEncryptedOrderIdEventsByOldEventIdStartErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/exchange/{encryptedOrderId}/events/{oldEventId}/start',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Drops an exchange in progress, releasing the seats its staging order holds. The original order and
 * its tickets are left exactly as they were. Succeeds when there is nothing in flight, so calling it
 * twice is harmless; returns 409 once the exchange has been applied or while a payment is closing.
 */
export const deleteApiExchangeByEncryptedOrderId = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiExchangeByEncryptedOrderIdData, ThrowOnError>): RequestResult<DeleteApiExchangeByEncryptedOrderIdResponses, DeleteApiExchangeByEncryptedOrderIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiExchangeByEncryptedOrderIdResponses, DeleteApiExchangeByEncryptedOrderIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/exchange/{encryptedOrderId}',
  ...options
});

/**
 * Returns the exchange (staging) order as a normal cart plus the exchange overlay:
 * returned tickets, change fee, and net amount to settle.
 */
export const getApiExchangeByEncryptedOrderIdCart = <ThrowOnError extends boolean = false,>(options: Options<GetApiExchangeByEncryptedOrderIdCartData, ThrowOnError>): RequestResult<GetApiExchangeByEncryptedOrderIdCartResponses, GetApiExchangeByEncryptedOrderIdCartErrors, ThrowOnError> => (options.client ?? client).get<GetApiExchangeByEncryptedOrderIdCartResponses, GetApiExchangeByEncryptedOrderIdCartErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/exchange/{encryptedOrderId}/cart',
  ...options
});

/**
 * Creates a Briqpay payment session for the exchange's net amount (change fee + upgrade, less any
 * returned-ticket credit). Returns 409 when no payment is required (net zero).
 */
export const postApiExchangeByEncryptedOrderIdPaymentSession = <ThrowOnError extends boolean = false,>(options: Options<PostApiExchangeByEncryptedOrderIdPaymentSessionData, ThrowOnError>): RequestResult<PostApiExchangeByEncryptedOrderIdPaymentSessionResponses, PostApiExchangeByEncryptedOrderIdPaymentSessionErrors, ThrowOnError> => (options.client ?? client).post<PostApiExchangeByEncryptedOrderIdPaymentSessionResponses, PostApiExchangeByEncryptedOrderIdPaymentSessionErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/exchange/{encryptedOrderId}/payment-session',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Finalizes an exchange that needs no payment (equal swap, free change, or a cheaper swap whose
 * excess is refunded as gift card / donation). The frontend calls this after
 * `payment-session` returns `NoPaymentRequired`. Returns the original order id for the receipt.
 */
export const postApiExchangeByEncryptedOrderIdFinalize = <ThrowOnError extends boolean = false,>(options: Options<PostApiExchangeByEncryptedOrderIdFinalizeData, ThrowOnError>): RequestResult<PostApiExchangeByEncryptedOrderIdFinalizeResponses, PostApiExchangeByEncryptedOrderIdFinalizeErrors, ThrowOnError> => (options.client ?? client).post<PostApiExchangeByEncryptedOrderIdFinalizeResponses, PostApiExchangeByEncryptedOrderIdFinalizeErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/exchange/{encryptedOrderId}/finalize',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Confirms an exchange — swaps old tickets for new reserved tickets and writes audit entries
 */
export const postApiExchangeByEncryptedOrderIdEventsByEventIdConfirm = <ThrowOnError extends boolean = false,>(options: Options<PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmData, ThrowOnError>): RequestResult<PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmResponses, PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmErrors, ThrowOnError> => (options.client ?? client).post<PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmResponses, PostApiExchangeByEncryptedOrderIdEventsByEventIdConfirmErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/exchange/{encryptedOrderId}/events/{eventId}/confirm',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Returns a list of available external providers
 */
export const getApiAuthExternalProviders = <ThrowOnError extends boolean = false,>(options?: Options<GetApiAuthExternalProvidersData, ThrowOnError>): RequestResult<GetApiAuthExternalProvidersResponses, GetApiAuthExternalProvidersErrors, ThrowOnError> => (options?.client ?? client).get<GetApiAuthExternalProvidersResponses, GetApiAuthExternalProvidersErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/external/providers',
  ...options
});

/**
 * Logs in (or signs up) a web user using an external provider
 */
export const postApiAuthExternalLogin = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthExternalLoginData, ThrowOnError>): RequestResult<PostApiAuthExternalLoginResponses, PostApiAuthExternalLoginErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthExternalLoginResponses, PostApiAuthExternalLoginErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/external/login',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Disconnect a web user from an external provider
 */
export const postApiAuthExternalDisconnect = <ThrowOnError extends boolean = false,>(options?: Options<PostApiAuthExternalDisconnectData, ThrowOnError>): RequestResult<PostApiAuthExternalDisconnectResponses, PostApiAuthExternalDisconnectErrors, ThrowOnError> => (options?.client ?? client).post<PostApiAuthExternalDisconnectResponses, PostApiAuthExternalDisconnectErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/external/disconnect',
  ...options
});

/**
 * Begins the flow by redirecting the browser to the provider's authorize URL.
 */
export const getApiAuthExternalStart = <ThrowOnError extends boolean = false,>(options?: Options<GetApiAuthExternalStartData, ThrowOnError>): RequestResult<GetApiAuthExternalStartResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiAuthExternalStartResponses, unknown, ThrowOnError>({
  url: '/api/auth/external/start',
  ...options
});

/**
 * Provider callback. Redirects back to the tenant's return URL with a one-time code appended.
 * OAuth 2.0 providers return `code`; Twitter (OAuth 1.0a) returns
 * `oauth_token`/`oauth_verifier`.
 */
export const getApiAuthExternalCallback = <ThrowOnError extends boolean = false,>(options?: Options<GetApiAuthExternalCallbackData, ThrowOnError>): RequestResult<GetApiAuthExternalCallbackResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiAuthExternalCallbackResponses, unknown, ThrowOnError>({
  url: '/api/auth/external/callback',
  ...options
});

/**
 * Redeems the exchange token for a JWT token pair. The token and the PKCE code verifier travel in
 * the body (never a URL), so a token captured from a URL or log can't be redeemed without the verifier.
 */
export const postApiAuthExternalExchange = <ThrowOnError extends boolean = false,>(options: Options<PostApiAuthExternalExchangeData, ThrowOnError>): RequestResult<PostApiAuthExternalExchangeResponses, PostApiAuthExternalExchangeErrors, ThrowOnError> => (options.client ?? client).post<PostApiAuthExternalExchangeResponses, PostApiAuthExternalExchangeErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/auth/external/exchange',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Forwards the selected tickets to a recipient email and returns the forward token (for "copy link").
 */
export const postApiForward = <ThrowOnError extends boolean = false,>(options: Options<PostApiForwardData, ThrowOnError>): RequestResult<PostApiForwardResponses, PostApiForwardErrors, ThrowOnError> => (options.client ?? client).post<PostApiForwardResponses, PostApiForwardErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/forward',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Builds the shareable download token for the selected tickets without sending an email.
 */
export const postApiForwardLink = <ThrowOnError extends boolean = false,>(options: Options<PostApiForwardLinkData, ThrowOnError>): RequestResult<PostApiForwardLinkResponses, PostApiForwardLinkErrors, ThrowOnError> => (options.client ?? client).post<PostApiForwardLinkResponses, PostApiForwardLinkErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/forward/link',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Streams the PDF for the tickets encoded in a forward token, for an account-less recipient
 * following a forwarded link. The token is the only credential.
 */
export const getApiForwardByTokenPdf = <ThrowOnError extends boolean = false,>(options: Options<GetApiForwardByTokenPdfData, ThrowOnError>): RequestResult<GetApiForwardByTokenPdfResponses, GetApiForwardByTokenPdfErrors, ThrowOnError> => (options.client ?? client).get<GetApiForwardByTokenPdfResponses, GetApiForwardByTokenPdfErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/forward/{token}/pdf',
  ...options
});

/**
 * Retrieves GiftCard status by number and pin
 */
export const postApiGiftcardsStatus = <ThrowOnError extends boolean = false,>(options: Options<PostApiGiftcardsStatusData, ThrowOnError>): RequestResult<PostApiGiftcardsStatusResponses, PostApiGiftcardsStatusErrors, ThrowOnError> => (options.client ?? client).post<PostApiGiftcardsStatusResponses, PostApiGiftcardsStatusErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/giftcards/status',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Retrieves available GiftCards Groups for the Skin
 */
export const getApiGiftcardsGroups = <ThrowOnError extends boolean = false,>(options?: Options<GetApiGiftcardsGroupsData, ThrowOnError>): RequestResult<GetApiGiftcardsGroupsResponses, GetApiGiftcardsGroupsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiGiftcardsGroupsResponses, GetApiGiftcardsGroupsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/giftcards/groups',
  ...options
});

/**
 * Retrieves GiftCard Group By GiftCardGroupId if available
 */
export const getApiGiftcardsGroupsByGiftCardGroupId = <ThrowOnError extends boolean = false,>(options: Options<GetApiGiftcardsGroupsByGiftCardGroupIdData, ThrowOnError>): RequestResult<GetApiGiftcardsGroupsByGiftCardGroupIdResponses, GetApiGiftcardsGroupsByGiftCardGroupIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiGiftcardsGroupsByGiftCardGroupIdResponses, GetApiGiftcardsGroupsByGiftCardGroupIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/giftcards/groups/{giftCardGroupId}',
  ...options
});

/**
 * Streams a pre-purchase gift-card preview PDF, rendered by the PDF service, for the buyer's chosen
 * layout, amount and message.
 */
export const postApiGiftcardsPreviewPdf = <ThrowOnError extends boolean = false,>(options: Options<PostApiGiftcardsPreviewPdfData, ThrowOnError>): RequestResult<PostApiGiftcardsPreviewPdfResponses, PostApiGiftcardsPreviewPdfErrors, ThrowOnError> => (options.client ?? client).post<PostApiGiftcardsPreviewPdfResponses, PostApiGiftcardsPreviewPdfErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/giftcards/preview-pdf',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Applies Briqpay's final refund_status. Idempotent: a finished refund returns 200.
 */
export const postApiInternalOrdersByOrderIdBriqpayRefund = <ThrowOnError extends boolean = false,>(options: Options<PostApiInternalOrdersByOrderIdBriqpayRefundData, ThrowOnError>): RequestResult<PostApiInternalOrdersByOrderIdBriqpayRefundResponses, PostApiInternalOrdersByOrderIdBriqpayRefundErrors, ThrowOnError> => (options.client ?? client).post<PostApiInternalOrdersByOrderIdBriqpayRefundResponses, PostApiInternalOrdersByOrderIdBriqpayRefundErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/internal/orders/{orderId}/briqpay-refund',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Closes the sale for an order whose payment was approved by an external PSP.
 * Idempotent: repeat calls after a completed close return 200.
 */
export const postApiInternalOrdersByOrderIdCloseSale = <ThrowOnError extends boolean = false,>(options: Options<PostApiInternalOrdersByOrderIdCloseSaleData, ThrowOnError>): RequestResult<PostApiInternalOrdersByOrderIdCloseSaleResponses, PostApiInternalOrdersByOrderIdCloseSaleErrors, ThrowOnError> => (options.client ?? client).post<PostApiInternalOrdersByOrderIdCloseSaleResponses, PostApiInternalOrdersByOrderIdCloseSaleErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/internal/orders/{orderId}/close-sale',
  ...options
});

/**
 * Retrieves available individual memberships for the Skin
 */
export const getApiMemberships = <ThrowOnError extends boolean = false,>(options?: Options<GetApiMembershipsData, ThrowOnError>): RequestResult<GetApiMembershipsResponses, GetApiMembershipsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiMembershipsResponses, GetApiMembershipsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/memberships',
  ...options
});

/**
 * Retrieves individual membership detail by ID
 */
export const getApiMembershipsByMembershipId = <ThrowOnError extends boolean = false,>(options: Options<GetApiMembershipsByMembershipIdData, ThrowOnError>): RequestResult<GetApiMembershipsByMembershipIdResponses, GetApiMembershipsByMembershipIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiMembershipsByMembershipIdResponses, GetApiMembershipsByMembershipIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/memberships/{membershipId}',
  ...options
});

/**
 * Retrieves available Membership Groups for the Skin
 */
export const getApiMembershipsGroups = <ThrowOnError extends boolean = false,>(options?: Options<GetApiMembershipsGroupsData, ThrowOnError>): RequestResult<GetApiMembershipsGroupsResponses, GetApiMembershipsGroupsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiMembershipsGroupsResponses, GetApiMembershipsGroupsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/memberships/groups',
  ...options
});

/**
 * Retrieves Membership Group detail by URL slug
 */
export const getApiMembershipsGroupsByUrl = <ThrowOnError extends boolean = false,>(options: Options<GetApiMembershipsGroupsByUrlData, ThrowOnError>): RequestResult<GetApiMembershipsGroupsByUrlResponses, GetApiMembershipsGroupsByUrlErrors, ThrowOnError> => (options.client ?? client).get<GetApiMembershipsGroupsByUrlResponses, GetApiMembershipsGroupsByUrlErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/memberships/groups/{url}',
  ...options
});

/**
 * Retrieves the mobile pass for a ticket
 */
export const getApiMobilepassTicketByEncryptedTicketId = <ThrowOnError extends boolean = false,>(options: Options<GetApiMobilepassTicketByEncryptedTicketIdData, ThrowOnError>): RequestResult<GetApiMobilepassTicketByEncryptedTicketIdResponses, GetApiMobilepassTicketByEncryptedTicketIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiMobilepassTicketByEncryptedTicketIdResponses, GetApiMobilepassTicketByEncryptedTicketIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/mobilepass/ticket/{encryptedTicketId}',
  ...options
});

/**
 * Retrieves the mobile pass for a membership
 */
export const getApiMobilepassMembershipByEncryptedMembershipInstanceId = <ThrowOnError extends boolean = false,>(options: Options<GetApiMobilepassMembershipByEncryptedMembershipInstanceIdData, ThrowOnError>): RequestResult<GetApiMobilepassMembershipByEncryptedMembershipInstanceIdResponses, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiMobilepassMembershipByEncryptedMembershipInstanceIdResponses, GetApiMobilepassMembershipByEncryptedMembershipInstanceIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/mobilepass/membership/{encryptedMembershipInstanceId}',
  ...options
});

/**
 * Retrieves the mobile pass for a giftcard
 */
export const getApiMobilepassGiftcardByEncryptedGiftcardId = <ThrowOnError extends boolean = false,>(options: Options<GetApiMobilepassGiftcardByEncryptedGiftcardIdData, ThrowOnError>): RequestResult<GetApiMobilepassGiftcardByEncryptedGiftcardIdResponses, GetApiMobilepassGiftcardByEncryptedGiftcardIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiMobilepassGiftcardByEncryptedGiftcardIdResponses, GetApiMobilepassGiftcardByEncryptedGiftcardIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/mobilepass/giftcard/{encryptedGiftcardId}',
  ...options
});

/**
 * Retrieves every wallet-eligible item on a sold order as one archive
 */
export const getApiMobilepassOrderByEncryptedOrderId = <ThrowOnError extends boolean = false,>(options: Options<GetApiMobilepassOrderByEncryptedOrderIdData, ThrowOnError>): RequestResult<GetApiMobilepassOrderByEncryptedOrderIdResponses, GetApiMobilepassOrderByEncryptedOrderIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiMobilepassOrderByEncryptedOrderIdResponses, GetApiMobilepassOrderByEncryptedOrderIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/mobilepass/order/{encryptedOrderId}',
  ...options
});

/**
 * Creates the Apple Wallet links for a contactless order's tickets and subscriptions
 *
 * Call when the receipt's `walletBundle.isContactless` is true, on iOS only. Render each link as a plain
 * anchor the customer taps: Wallet only opens a universal link on a real navigation. Usually one link; an order
 * from several organisations, or with more passes than Wallet adds at once, gets several. The per-item and
 * bundle passes stay available for Android and older devices.
 */
export const postApiMobilepassOrderByEncryptedOrderIdAppleWalletLinks = <ThrowOnError extends boolean = false,>(options: Options<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksData, ThrowOnError>): RequestResult<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksResponses, PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksErrors, ThrowOnError> => (options.client ?? client).post<PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksResponses, PostApiMobilepassOrderByEncryptedOrderIdAppleWalletLinksErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/mobilepass/order/{encryptedOrderId}/apple-wallet-links',
  ...options
});

/**
 * Retrieves the mobile pass for a subscription
 */
export const getApiMobilepassSubscriptionByEncryptedTicketId = <ThrowOnError extends boolean = false,>(options: Options<GetApiMobilepassSubscriptionByEncryptedTicketIdData, ThrowOnError>): RequestResult<GetApiMobilepassSubscriptionByEncryptedTicketIdResponses, GetApiMobilepassSubscriptionByEncryptedTicketIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiMobilepassSubscriptionByEncryptedTicketIdResponses, GetApiMobilepassSubscriptionByEncryptedTicketIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/mobilepass/subscription/{encryptedTicketId}',
  ...options
});

/**
 * Cancels the customer's own reservation, releasing its seats back to the venue
 */
export const deleteApiOrdersByEncryptedOrderId = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiOrdersByEncryptedOrderIdData, ThrowOnError>): RequestResult<DeleteApiOrdersByEncryptedOrderIdResponses, DeleteApiOrdersByEncryptedOrderIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiOrdersByEncryptedOrderIdResponses, DeleteApiOrdersByEncryptedOrderIdErrors, ThrowOnError>({
  url: '/api/orders/{encryptedOrderId}',
  ...options
});

/**
 * Attempts to retrieve a order specified by orderId
 */
export const getApiOrdersByEncryptedOrderId = <ThrowOnError extends boolean = false,>(options: Options<GetApiOrdersByEncryptedOrderIdData, ThrowOnError>): RequestResult<GetApiOrdersByEncryptedOrderIdResponses, GetApiOrdersByEncryptedOrderIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiOrdersByEncryptedOrderIdResponses, GetApiOrdersByEncryptedOrderIdErrors, ThrowOnError>({
  url: '/api/orders/{encryptedOrderId}',
  ...options
});

/**
 * Attempts to "claim" a special offer using either a password (in request body) or web user access (if authenticated)
 */
export const postApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferId = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdResponses, PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdResponses, PostApiOrdersByEncryptedOrderIdSpecialOffersBySpecialOfferIdErrors, ThrowOnError>({
  url: '/api/orders/{encryptedOrderId}/special-offers/{specialOfferId}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Attempts to add the specified unnumbered tickets to the order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdTicketsUnnumbered = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedResponses, PostApiOrdersByEncryptedOrderIdTicketsUnnumberedErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdTicketsUnnumberedResponses, PostApiOrdersByEncryptedOrderIdTicketsUnnumberedErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/tickets/unnumbered',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Updates the CustomerNote property on an order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdCustomerNote = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdCustomerNoteData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdCustomerNoteResponses, PostApiOrdersByEncryptedOrderIdCustomerNoteErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdCustomerNoteResponses, PostApiOrdersByEncryptedOrderIdCustomerNoteErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/customer-note',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Extends the expiry time of the specified order by 5 minutes.
 */
export const postApiOrdersByEncryptedOrderIdExpiryExtend = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdExpiryExtendData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdExpiryExtendResponses, PostApiOrdersByEncryptedOrderIdExpiryExtendErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdExpiryExtendResponses, PostApiOrdersByEncryptedOrderIdExpiryExtendErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/expiry/extend',
  ...options
});

/**
 * Fetches the available delivery types for the specified order.
 */
export const getApiOrdersByEncryptedOrderIdDeliveryTypes = <ThrowOnError extends boolean = false,>(options: Options<GetApiOrdersByEncryptedOrderIdDeliveryTypesData, ThrowOnError>): RequestResult<GetApiOrdersByEncryptedOrderIdDeliveryTypesResponses, GetApiOrdersByEncryptedOrderIdDeliveryTypesErrors, ThrowOnError> => (options.client ?? client).get<GetApiOrdersByEncryptedOrderIdDeliveryTypesResponses, GetApiOrdersByEncryptedOrderIdDeliveryTypesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/delivery-types',
  ...options
});

/**
 * Attempts to remove everything connected to an event in the order
 */
export const deleteApiOrdersByEncryptedOrderIdEventByEventId = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiOrdersByEncryptedOrderIdEventByEventIdData, ThrowOnError>): RequestResult<DeleteApiOrdersByEncryptedOrderIdEventByEventIdResponses, DeleteApiOrdersByEncryptedOrderIdEventByEventIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiOrdersByEncryptedOrderIdEventByEventIdResponses, DeleteApiOrdersByEncryptedOrderIdEventByEventIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/event/{eventId}',
  ...options
});

/**
 * Attempts to delete tickets from an order
 */
export const deleteApiOrdersByEncryptedOrderIdTickets = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiOrdersByEncryptedOrderIdTicketsData, ThrowOnError>): RequestResult<DeleteApiOrdersByEncryptedOrderIdTicketsResponses, DeleteApiOrdersByEncryptedOrderIdTicketsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiOrdersByEncryptedOrderIdTicketsResponses, DeleteApiOrdersByEncryptedOrderIdTicketsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/tickets',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Attempts to add tickets to an order
 */
export const postApiOrdersByEncryptedOrderIdTickets = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdTicketsData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdTicketsResponses, PostApiOrdersByEncryptedOrderIdTicketsErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdTicketsResponses, PostApiOrdersByEncryptedOrderIdTicketsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/tickets',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Attempts to create an order with tickets
 */
export const postApiOrders = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersData, ThrowOnError>): RequestResult<PostApiOrdersResponses, PostApiOrdersErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersResponses, PostApiOrdersErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Attempts to claim an order
 */
export const postApiOrdersByEncryptedOrderIdClaim = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdClaimData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdClaimResponses, PostApiOrdersByEncryptedOrderIdClaimErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdClaimResponses, PostApiOrdersByEncryptedOrderIdClaimErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/claim',
  ...options
});

/**
 * Evaluates basket rules for the order, applying any discount code already on it.
 */
export const postApiOrdersByEncryptedOrderIdEvaluateRules = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdEvaluateRulesData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdEvaluateRulesResponses, PostApiOrdersByEncryptedOrderIdEvaluateRulesErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdEvaluateRulesResponses, PostApiOrdersByEncryptedOrderIdEvaluateRulesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/evaluate-rules',
  ...options
});

/**
 * Applies a discount code to the order, matching it against event vouchers first and then
 * promo-code basket rules.
 */
export const postApiOrdersByEncryptedOrderIdDiscountCode = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdDiscountCodeData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdDiscountCodeResponses, PostApiOrdersByEncryptedOrderIdDiscountCodeErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdDiscountCodeResponses, PostApiOrdersByEncryptedOrderIdDiscountCodeErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/discount-code',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Returns attendee form data for a single event in the order, with each row pre-populated
 * from the reservation's customer or left empty for anonymous reservations.
 */
export const getApiOrdersByEncryptedOrderIdEventsByEventIdAttendees = <ThrowOnError extends boolean = false,>(options: Options<GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData, ThrowOnError>): RequestResult<GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponses, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesErrors, ThrowOnError> => (options.client ?? client).get<GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponses, GetApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/events/{eventId}/attendees',
  ...options
});

/**
 * Updates attendee information on tickets for a single event in the order.
 */
export const patchApiOrdersByEncryptedOrderIdEventsByEventIdAttendees = <ThrowOnError extends boolean = false,>(options: Options<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesData, ThrowOnError>): RequestResult<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponses, PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesResponses, PatchApiOrdersByEncryptedOrderIdEventsByEventIdAttendeesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/events/{eventId}/attendees',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Deletes a gift card from the order
 */
export const deleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardId = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdData, ThrowOnError>): RequestResult<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdResponses, DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdResponses, DeleteApiOrdersByEncryptedOrderIdGiftcardsByGiftCardIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/giftcards/{giftCardId}',
  ...options
});

/**
 * Adds gift cards to the order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdGiftcards = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdGiftcardsData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdGiftcardsResponses, PostApiOrdersByEncryptedOrderIdGiftcardsErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdGiftcardsResponses, PostApiOrdersByEncryptedOrderIdGiftcardsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/giftcards',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Deletes a membership from the order
 */
export const deleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipId = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdData, ThrowOnError>): RequestResult<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdResponses, DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdResponses, DeleteApiOrdersByEncryptedOrderIdMembershipsByOrderMembershipIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/memberships/{orderMembershipId}',
  ...options
});

/**
 * Adds a membership to the order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdMemberships = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdMembershipsData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdMembershipsResponses, PostApiOrdersByEncryptedOrderIdMembershipsErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdMembershipsResponses, PostApiOrdersByEncryptedOrderIdMembershipsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/memberships',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Deletes a donation from the order
 */
export const deleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationId = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdData, ThrowOnError>): RequestResult<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdResponses, DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdResponses, DeleteApiOrdersByEncryptedOrderIdDonationsByOrderDonationIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/donations/{orderDonationId}',
  ...options
});

/**
 * Adds a donation to the order specified by orderId
 */
export const postApiOrdersByEncryptedOrderIdDonations = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdDonationsData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdDonationsResponses, PostApiOrdersByEncryptedOrderIdDonationsErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdDonationsResponses, PostApiOrdersByEncryptedOrderIdDonationsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/donations',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Removes add-on product units from the order, all or nothing. Each id is the EncryptedOrderProductId of one
 * unit; refuses with 409 for an id that is not an add-on on this order, or when the removal would leave a
 * product without the product it can only be bought together with.
 */
export const deleteApiOrdersByEncryptedOrderIdProducts = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiOrdersByEncryptedOrderIdProductsData, ThrowOnError>): RequestResult<DeleteApiOrdersByEncryptedOrderIdProductsResponses, DeleteApiOrdersByEncryptedOrderIdProductsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiOrdersByEncryptedOrderIdProductsResponses, DeleteApiOrdersByEncryptedOrderIdProductsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/products',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Adds product variants for an event the order holds tickets for. All or nothing: refuses with 409
 * naming the item when the event quota or stock cannot cover the whole request.
 */
export const postApiOrdersByEncryptedOrderIdProducts = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdProductsData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdProductsResponses, PostApiOrdersByEncryptedOrderIdProductsErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdProductsResponses, PostApiOrdersByEncryptedOrderIdProductsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/products',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Moves the selected items onto a new reservation, leaving this order holding the rest. The
 * order keeps its id and is the one that goes on to be paid.
 */
export const postApiOrdersByEncryptedOrderIdSplit = <ThrowOnError extends boolean = false,>(options: Options<PostApiOrdersByEncryptedOrderIdSplitData, ThrowOnError>): RequestResult<PostApiOrdersByEncryptedOrderIdSplitResponses, PostApiOrdersByEncryptedOrderIdSplitErrors, ThrowOnError> => (options.client ?? client).post<PostApiOrdersByEncryptedOrderIdSplitResponses, PostApiOrdersByEncryptedOrderIdSplitErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/orders/{encryptedOrderId}/split',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Retrieves the products and product variants sellable online for an event, with the event's texts for the products step
 */
export const getApiEventsByEventIdProducts = <ThrowOnError extends boolean = false,>(options: Options<GetApiEventsByEventIdProductsData, ThrowOnError>): RequestResult<GetApiEventsByEventIdProductsResponses, GetApiEventsByEventIdProductsErrors, ThrowOnError> => (options.client ?? client).get<GetApiEventsByEventIdProductsResponses, GetApiEventsByEventIdProductsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/events/{eventId}/products',
  ...options
});

/**
 * Anonymises the logged-in web user's customer record and retires the login. Only available when
 * the workgroup allows user deletion.
 */
export const deleteApiProfileMe = <ThrowOnError extends boolean = false,>(options?: Options<DeleteApiProfileMeData, ThrowOnError>): RequestResult<DeleteApiProfileMeResponses, DeleteApiProfileMeErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteApiProfileMeResponses, DeleteApiProfileMeErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/me',
  ...options
});

/**
 * Attempts to retrieve the user profile for the logged-in web user
 */
export const getApiProfileMe = <ThrowOnError extends boolean = false,>(options?: Options<GetApiProfileMeData, ThrowOnError>): RequestResult<GetApiProfileMeResponses, GetApiProfileMeErrors, ThrowOnError> => (options?.client ?? client).get<GetApiProfileMeResponses, GetApiProfileMeErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/me',
  ...options
});

/**
 * Updates WebCustomer attributes for the logged-in web user
 */
export const postApiProfileMe = <ThrowOnError extends boolean = false,>(options: Options<PostApiProfileMeData, ThrowOnError>): RequestResult<PostApiProfileMeResponses, PostApiProfileMeErrors, ThrowOnError> => (options.client ?? client).post<PostApiProfileMeResponses, PostApiProfileMeErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/me',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Updates the date of birth for the logged-in user's customer record
 */
export const patchApiProfileMeDateOfBirth = <ThrowOnError extends boolean = false,>(options: Options<PatchApiProfileMeDateOfBirthData, ThrowOnError>): RequestResult<PatchApiProfileMeDateOfBirthResponses, PatchApiProfileMeDateOfBirthErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiProfileMeDateOfBirthResponses, PatchApiProfileMeDateOfBirthErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/me/date-of-birth',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Returns a zip of CSV files covering every record this workgroup holds about the logged-in
 * web user. Only available when the workgroup allows user data export.
 */
export const getApiProfileMeExport = <ThrowOnError extends boolean = false,>(options?: Options<GetApiProfileMeExportData, ThrowOnError>): RequestResult<GetApiProfileMeExportResponses, GetApiProfileMeExportErrors, ThrowOnError> => (options?.client ?? client).get<GetApiProfileMeExportResponses, GetApiProfileMeExportErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/me/export',
  ...options
});

/**
 * Returns the marketing permissions visible to the logged-in web user, each with the toggle
 * state the buyer should see. A permission answered per performance appears once per event.
 */
export const getApiProfileMePermissions = <ThrowOnError extends boolean = false,>(options?: Options<GetApiProfileMePermissionsData, ThrowOnError>): RequestResult<GetApiProfileMePermissionsResponses, GetApiProfileMePermissionsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiProfileMePermissionsResponses, GetApiProfileMePermissionsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/me/permissions',
  ...options
});

/**
 * Records the logged-in web user's answer to one marketing permission.
 */
export const putApiProfileMePermissionsByPermissionId = <ThrowOnError extends boolean = false,>(options: Options<PutApiProfileMePermissionsByPermissionIdData, ThrowOnError>): RequestResult<PutApiProfileMePermissionsByPermissionIdResponses, PutApiProfileMePermissionsByPermissionIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiProfileMePermissionsByPermissionIdResponses, PutApiProfileMePermissionsByPermissionIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/me/permissions/{permissionId}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Attempts to retrieve all orders belonging to the logged-in web user
 */
export const getApiProfileOrders = <ThrowOnError extends boolean = false,>(options?: Options<GetApiProfileOrdersData, ThrowOnError>): RequestResult<GetApiProfileOrdersResponses, GetApiProfileOrdersErrors, ThrowOnError> => (options?.client ?? client).get<GetApiProfileOrdersResponses, GetApiProfileOrdersErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/orders',
  ...options
});

/**
 * Retrieves gift cards belonging to the logged-in web user
 */
export const getApiProfileGiftcards = <ThrowOnError extends boolean = false,>(options?: Options<GetApiProfileGiftcardsData, ThrowOnError>): RequestResult<GetApiProfileGiftcardsResponses, GetApiProfileGiftcardsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiProfileGiftcardsResponses, GetApiProfileGiftcardsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/giftcards',
  ...options
});

/**
 * Retrieves memberships belonging to the logged-in web user
 */
export const getApiProfileMemberships = <ThrowOnError extends boolean = false,>(options?: Options<GetApiProfileMembershipsData, ThrowOnError>): RequestResult<GetApiProfileMembershipsResponses, GetApiProfileMembershipsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiProfileMembershipsResponses, GetApiProfileMembershipsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/memberships',
  ...options
});

/**
 * Cancels auto-renewal for a membership instance belonging to the logged-in web user
 */
export const postApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewal = <ThrowOnError extends boolean = false,>(options: Options<PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalData, ThrowOnError>): RequestResult<PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalResponses, PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalErrors, ThrowOnError> => (options.client ?? client).post<PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalResponses, PostApiProfileMembershipsByEncryptedMembershipInstanceIdCancelRenewalErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/memberships/{encryptedMembershipInstanceId}/cancel-renewal',
  ...options
});

/**
 * Enables auto-renewal for a membership instance belonging to the logged-in web user
 */
export const postApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewal = <ThrowOnError extends boolean = false,>(options: Options<PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalData, ThrowOnError>): RequestResult<PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalResponses, PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalErrors, ThrowOnError> => (options.client ?? client).post<PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalResponses, PostApiProfileMembershipsByEncryptedMembershipInstanceIdEnableRenewalErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/memberships/{encryptedMembershipInstanceId}/enable-renewal',
  ...options
});

/**
 * Returns the merged attendee form for every ticket the logged-in user owns for a single
 * event, across all their sold orders. Used by the My Pages "Edit attendee info" entry
 * so the user never has to disambiguate between multiple orders covering the same event.
 */
export const getApiProfileEventsByEventIdAttendees = <ThrowOnError extends boolean = false,>(options: Options<GetApiProfileEventsByEventIdAttendeesData, ThrowOnError>): RequestResult<GetApiProfileEventsByEventIdAttendeesResponses, GetApiProfileEventsByEventIdAttendeesErrors, ThrowOnError> => (options.client ?? client).get<GetApiProfileEventsByEventIdAttendeesResponses, GetApiProfileEventsByEventIdAttendeesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/events/{eventId}/attendees',
  ...options
});

/**
 * Updates attendee information for the logged-in user's tickets across every sold order
 * containing the event in a single transactional write. Validates the event's uniqueness
 * constraints against the full merged set before persisting.
 */
export const patchApiProfileEventsByEventIdAttendees = <ThrowOnError extends boolean = false,>(options: Options<PatchApiProfileEventsByEventIdAttendeesData, ThrowOnError>): RequestResult<PatchApiProfileEventsByEventIdAttendeesResponses, PatchApiProfileEventsByEventIdAttendeesErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiProfileEventsByEventIdAttendeesResponses, PatchApiProfileEventsByEventIdAttendeesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/profile/events/{eventId}/attendees',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Attempts to purchase the order and create a sale
 */
export const postApiPurchaseByEncryptedOrderId = <ThrowOnError extends boolean = false,>(options: Options<PostApiPurchaseByEncryptedOrderIdData, ThrowOnError>): RequestResult<PostApiPurchaseByEncryptedOrderIdResponses, PostApiPurchaseByEncryptedOrderIdErrors, ThrowOnError> => (options.client ?? client).post<PostApiPurchaseByEncryptedOrderIdResponses, PostApiPurchaseByEncryptedOrderIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/purchase/{encryptedOrderId}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Attempts to get receipt for the order
 */
export const getApiReceiptByEncryptedOrderId = <ThrowOnError extends boolean = false,>(options: Options<GetApiReceiptByEncryptedOrderIdData, ThrowOnError>): RequestResult<GetApiReceiptByEncryptedOrderIdResponses, GetApiReceiptByEncryptedOrderIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiReceiptByEncryptedOrderIdResponses, GetApiReceiptByEncryptedOrderIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/receipt/{encryptedOrderId}',
  ...options
});

/**
 * Refund options and amounts for one cancelled/moved event on the order, for the refund screen.
 */
export const getApiReceiptByEncryptedOrderIdRefundByEventId = <ThrowOnError extends boolean = false,>(options: Options<GetApiReceiptByEncryptedOrderIdRefundByEventIdData, ThrowOnError>): RequestResult<GetApiReceiptByEncryptedOrderIdRefundByEventIdResponses, GetApiReceiptByEncryptedOrderIdRefundByEventIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiReceiptByEncryptedOrderIdRefundByEventIdResponses, GetApiReceiptByEncryptedOrderIdRefundByEventIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/receipt/{encryptedOrderId}/refund/{eventId}',
  ...options
});

/**
 * Refunds all of the order's tickets for one cancelled/moved event, as a gift card, a donation, a
 * bank transfer, or back to the original payment method. That last one only registers for a card
 * order, so the tickets survive, and goes straight through Briqpay for a Briqpay order.
 */
export const postApiReceiptByEncryptedOrderIdRefundByEventId = <ThrowOnError extends boolean = false,>(options: Options<PostApiReceiptByEncryptedOrderIdRefundByEventIdData, ThrowOnError>): RequestResult<PostApiReceiptByEncryptedOrderIdRefundByEventIdResponses, PostApiReceiptByEncryptedOrderIdRefundByEventIdErrors, ThrowOnError> => (options.client ?? client).post<PostApiReceiptByEncryptedOrderIdRefundByEventIdResponses, PostApiReceiptByEncryptedOrderIdRefundByEventIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/receipt/{encryptedOrderId}/refund/{eventId}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Cheap pollable status while the FE waits for CloseSaleProcessor to consume the Briqpay webhook
 * and create the sale. Ready=true means it's safe to fetch the full receipt.
 */
export const getApiReceiptByEncryptedOrderIdStatus = <ThrowOnError extends boolean = false,>(options: Options<GetApiReceiptByEncryptedOrderIdStatusData, ThrowOnError>): RequestResult<GetApiReceiptByEncryptedOrderIdStatusResponses, GetApiReceiptByEncryptedOrderIdStatusErrors, ThrowOnError> => (options.client ?? client).get<GetApiReceiptByEncryptedOrderIdStatusResponses, GetApiReceiptByEncryptedOrderIdStatusErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/receipt/{encryptedOrderId}/status',
  ...options
});

/**
 * Streams one of the order's documents (ticket, receipt, ...), rendered by the PDF service,
 * back to the caller. The document type is bound from the route by its enum name (e.g. "Ticket").
 * Passing an encrypted item id narrows the document to that item, which My Pages uses to download
 * a single gift card or membership rather than every one on the order. The Invoice type instead
 * takes a transaction id from the receipt's invoice list, naming the invoice to render.
 */
export const getApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdf = <ThrowOnError extends boolean = false,>(options: Options<GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfData, ThrowOnError>): RequestResult<GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfResponses, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfErrors, ThrowOnError> => (options.client ?? client).get<GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfResponses, GetApiReceiptByEncryptedOrderIdDocumentsByDocumentTypePdfErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/receipt/{encryptedOrderId}/documents/{documentType}/pdf',
  ...options
});

/**
 * Retrieves special offer by encrypted specialOfferId
 */
export const getApiSpecialOffersByEncryptedSpecialOfferId = <ThrowOnError extends boolean = false,>(options: Options<GetApiSpecialOffersByEncryptedSpecialOfferIdData, ThrowOnError>): RequestResult<GetApiSpecialOffersByEncryptedSpecialOfferIdResponses, GetApiSpecialOffersByEncryptedSpecialOfferIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiSpecialOffersByEncryptedSpecialOfferIdResponses, GetApiSpecialOffersByEncryptedSpecialOfferIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/special-offers/{encryptedSpecialOfferId}',
  ...options
});

/**
 * Returns all active special offers available to the authenticated web user.
 */
export const getApiSpecialOffers = <ThrowOnError extends boolean = false,>(options?: Options<GetApiSpecialOffersData, ThrowOnError>): RequestResult<GetApiSpecialOffersResponses, GetApiSpecialOffersErrors, ThrowOnError> => (options?.client ?? client).get<GetApiSpecialOffersResponses, GetApiSpecialOffersErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/special-offers',
  ...options
});

/**
 * Retrieves the subscription types with a landing page on this storefront
 */
export const getApiSubscriptionTypes = <ThrowOnError extends boolean = false,>(options?: Options<GetApiSubscriptionTypesData, ThrowOnError>): RequestResult<GetApiSubscriptionTypesResponses, GetApiSubscriptionTypesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiSubscriptionTypesResponses, GetApiSubscriptionTypesErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/subscription-types',
  ...options
});

/**
 * Retrieves subscription type by Id
 */
export const getApiSubscriptionTypesBySubscriptionTypeId = <ThrowOnError extends boolean = false,>(options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdData, ThrowOnError>): RequestResult<GetApiSubscriptionTypesBySubscriptionTypeIdResponses, GetApiSubscriptionTypesBySubscriptionTypeIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiSubscriptionTypesBySubscriptionTypeIdResponses, GetApiSubscriptionTypesBySubscriptionTypeIdErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/subscription-types/{subscriptionTypeId}',
  ...options
});

/**
 * Retrieves event groups for a subscription with summary info.
 */
export const getApiSubscriptionTypesBySubscriptionTypeIdEventGroups = <ThrowOnError extends boolean = false,>(options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsData, ThrowOnError>): RequestResult<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsResponses, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsErrors, ThrowOnError> => (options.client ?? client).get<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsResponses, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/subscription-types/{subscriptionTypeId}/event-groups',
  ...options
});

/**
 * Retrieves paged events within a specific event group that are eligible for the given subscription type.
 */
export const getApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEvents = <ThrowOnError extends boolean = false,>(options: Options<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsData, ThrowOnError>): RequestResult<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsResponses, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsErrors, ThrowOnError> => (options.client ?? client).get<GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsResponses, GetApiSubscriptionTypesBySubscriptionTypeIdEventGroupsByEventGroupIdEventsErrors, ThrowOnError>({
  responseType: 'json',
  url: '/api/subscription-types/{subscriptionTypeId}/event-groups/{eventGroupId}/events',
  ...options
});

/**
 * Attempts to delete tickets
 */
export const deleteApiTickets = <ThrowOnError extends boolean = false,>(options: Options<DeleteApiTicketsData, ThrowOnError>): RequestResult<DeleteApiTicketsResponses, DeleteApiTicketsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiTicketsResponses, DeleteApiTicketsErrors, ThrowOnError>({
  url: '/api/tickets',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Validates a completed seat-picker step's reserved tickets (single-seat rule and per-event
 * subscription limits) so errors surface per step instead of only at order creation.
 */
export const postApiTicketsValidate = <ThrowOnError extends boolean = false,>(options: Options<PostApiTicketsValidateData, ThrowOnError>): RequestResult<PostApiTicketsValidateResponses, PostApiTicketsValidateErrors, ThrowOnError> => (options.client ?? client).post<PostApiTicketsValidateResponses, PostApiTicketsValidateErrors, ThrowOnError>({
  url: '/api/tickets/validate',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Attempts to update ticket type
 *
 * encryptedOrderId is the encrypted id of the order the ticket sits in, and is
 * required for any ticket that is in one, since it is what proves the caller may change this ticket.
 */
export const patchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeId = <ThrowOnError extends boolean = false,>(options: Options<PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdData, ThrowOnError>): RequestResult<PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdResponses, PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdResponses, PatchApiTicketsByEncryptedTicketIdTicketTypeByTicketTypeIdErrors, ThrowOnError>({
  url: '/api/tickets/{encryptedTicketId}/ticket-type/{ticketTypeId}',
  ...options
});

/**
 * Returns the deployed build version.
 */
export const getApiVersion = <ThrowOnError extends boolean = false,>(options?: Options<GetApiVersionData, ThrowOnError>): RequestResult<GetApiVersionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiVersionResponses, unknown, ThrowOnError>({
  responseType: 'json',
  url: '/api/version',
  ...options
});

/**
 * Registers a waiting-list signup for a sold-out event and sends the confirmation email.
 */
export const postApiWaitingListByEventIdSignup = <ThrowOnError extends boolean = false,>(options: Options<PostApiWaitingListByEventIdSignupData, ThrowOnError>): RequestResult<PostApiWaitingListByEventIdSignupResponses, PostApiWaitingListByEventIdSignupErrors, ThrowOnError> => (options.client ?? client).post<PostApiWaitingListByEventIdSignupResponses, PostApiWaitingListByEventIdSignupErrors, ThrowOnError>({
  url: '/api/waiting-list/{eventId}/signup',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Confirms a waiting-list signup from the emailed link (matches on signup id + email).
 */
export const postApiWaitingListConfirm = <ThrowOnError extends boolean = false,>(options: Options<PostApiWaitingListConfirmData, ThrowOnError>): RequestResult<PostApiWaitingListConfirmResponses, PostApiWaitingListConfirmErrors, ThrowOnError> => (options.client ?? client).post<PostApiWaitingListConfirmResponses, PostApiWaitingListConfirmErrors, ThrowOnError>({
  url: '/api/waiting-list/confirm',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});